var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 25.4881H7.99998V8.68442H13.3333V11.485C14.4701 9.96605 16.1941 9.0605 18.0333 9.01629C21.3407 9.03557 24.0096 11.8622 24 15.3359V25.4881H18.6666V16.036C18.4533 14.4714 17.1756 13.3104 15.6706 13.3138C15.0123 13.3357 14.391 13.6384 13.9499 14.1521C13.5088 14.6658 13.2862 15.3461 13.3333 16.036V25.4881ZM5.33332 25.4881H0V8.68442H5.33332V25.4881ZM2.66666 5.88381C1.1939 5.88381 0 4.62993 0 3.0832C0 1.53647 1.1939 0.282593 2.66666 0.282593C4.13942 0.282593 5.33332 1.53647 5.33332 3.0832C5.33332 3.82597 5.05237 4.53831 4.55228 5.06353C4.05218 5.58875 3.3739 5.88381 2.66666 5.88381Z",
    fill: "#3730A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.11d3d47e0cf9c155a4c99f45cf36dbcd.svg";
export { ForwardRef as ReactComponent };